<template>
  <b-card>
    <b-row>
      <b-col cols="12" class="mb-2">
        <i :class="`${setIcon(type)}`" class="fs-30 mr-2">
        </i>
        <span class="font-weight-bold fs-20">{{ text }}</span>
      </b-col>
      <b-col>
        <slot :quantity="quantity">
          <span class="fs-18">
            Qtde de clique: {{ quantity }}
          </span>
        </slot>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import LINKTREE from 'Enums/Linktree.js';
import { setIconsReport } from '@/utils/setIconsReport';

export default {
  name: 'ReportQuantityCard',
  props: {
    text: {
      type: String,
      required: true,
    },
    quantity: {
      type: String | Number,
      default: 0,
    },
    type: {
      type: String | Number,
    },
    icon: String,
  },

  data() {
    return {
      LINKTREE,
    };
  },
  methods: {
    setIcon(type) {
      return setIconsReport(type);
    }
  }
};
</script>

